import Game from "./Game";
import {PlayerSettings} from "./settings";
import User from "./User";
import System from "./System";
import Cue from "./Cue";
import SoundManager from "./SoundManager";
import BrowserDetect from "./lib/BrowserDetect";
import GameState from "./GameState";
import Match from "./Match";
import {InputModeState} from "./inputModeState";
import {TouchInput} from "./touchInput";


let Events:any = {
    keysPressed:{},
    Init: function(){
        let viewport = Game.Resources.renderer.domElement;
        viewport.addEventListener("click", function(event:any) {
            // Touch mode: no pointer lock or fullscreen on a tap; the fingers drive the cue (touchInput.ts)
            if (InputModeState.isTouch()) return;
            viewport.requestFullscreen = viewport.requestFullscreen ||
                viewport.mozRequestFullscreen ||
                viewport.mozRequestFullScreen || // Older API upper case 'S'.
                viewport.webkitRequestFullscreen;
            if (BrowserDetect.browser == "Firefox"){
                viewport.requestFullscreen();
            }

            if (!User.user.firstShotTime){
                System.DisplayMessage("Press and hold spacebar to lock aim");
            }

            viewport.requestPointerLock();
        }, false);

        document.addEventListener('keydown', this.onKeyPress, false);
        document.addEventListener('keyup', this.onKeyUp, false);
        document.addEventListener('mousewheel', this.onMouseWheel, false);
        document.addEventListener('DOMMouseScroll', this.onMouseWheel, false);
        window.addEventListener('resize', this.onWindowResize, false);

        // Ball contacts (first ball hit, the hit sound) come from the physics listener, Game.PhysicsListener.

        viewport.addEventListener("mousemove", this.onMouseMove, false);

        // Touch mode (phones, tablets, or the Settings override): look, lock and stroke with the fingers
        TouchInput.init(viewport);
    },
    /** Touch mode: keys typed into a form (the soft keyboard on the sign-in dialog) are not game keys. */
    touchTyping: function(event:any){
        if (!InputModeState.isTouch()) return false;
        const el = event && event.target;
        return !!el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName || ""));
    },
    BallHit : function(){

        SoundManager.PlayBallHit();
    },
    onKeyPress: function (event:any) {
        if (Events.touchTyping(event)) return;
        switch(event.keyCode){
            case 32: //space
                if (!Events.keysPressed.space) Cue.StartStroke(performance.now()); // ignore key repeat
                Events.keysPressed.space = true;
                if (!User.user.firstShotTime){
                    System.DisplayMessage("Drag the mouse back and then forward to hit the ball!");
                }
                break;
            case 37: //left
                Events.keysPressed.left = true;
                break;
            case 39: //right
                Events.keysPressed.right = true;
                break;
            case 38: //up
                Events.keysPressed.up = true;
                break;
            case 40:
                Events.keysPressed.down = true;
                break;
        }
    },
    onKeyUp: function (event:any){
        if (Events.touchTyping(event)) return;
        switch(event.keyCode){
            case 32: //space
                Events.keysPressed.space = false;
                Cue.EndStroke();

                if(!User.user.firstShotTime){
                    System.DisplayMessage("Press and hold spacebar to lock aim");
                }

                break;
            case 37: //left
                Events.keysPressed.left = false;
                break;
            case 39: //right
                Events.keysPressed.right = false;
                break;
            case 38: //up
                Events.keysPressed.up = false;
                break;
            case 40:
                Events.keysPressed.down = false;
                break;
        }
    },
    onMouseMove: function(event:any){
        if (document.pointerLockElement){
            if (Events.keysPressed.space){
                Cue.Stroke(event.movementY, event.timeStamp || performance.now());
            } else {
                // aim sensitivity setting (1 = original: movement / 200)
                const aim = PlayerSettings.get().aimSensitivity;
                Game.Camera.horizontalAngle -= event.movementX*aim/200;
                let newVerticalAngle = Game.Camera.verticalAngle + event.movementY*aim/200;
                if (newVerticalAngle < Math.PI/2 && newVerticalAngle> Math.PI/16){
                    Game.Camera.verticalAngle = newVerticalAngle;
                }
            }
        }
    },
    onMouseWheel: function (event:any){
        let delta = event.detail ? (event.detail*(-120)) : event.wheelDelta;

        if (GameState.cameraDistance - delta/240 > 0 && GameState.cameraDistance - delta/240 < 15.5){
            GameState.cameraDistance -= delta/240;
        }
    },
    onWindowResize: function () {
        Game.Camera.aspect = Game.Resources.width / Game.Resources.height;
        Game.Camera.updateProjectionMatrix();

        Game.Resources.renderer.setSize(Game.Resources.width, Game.Resources.height);

    }
};

export default Events;